/**
 * Giving runs entirely through PayPal: a hosted "Support Orthodox Way"
 * payment button, its direct link, and a QR code of that link. Nothing
 * here is secret. The client id is PayPal's browser-side id for the
 * account, meant to be embedded in pages, and the hosted button id is
 * public by nature. Change the button in PayPal (Pay & Get Paid → Payment
 * links & buttons) and update the ids here.
 */
export const PAYPAL_CLIENT_ID =
  'BAAU-Y6mJ2aOQNh4D-RZNLcuuGcl7ykm_7aBwIGqClnsxdRK5qd4Hd9RUzvrTzRTndF7At6Q_eh0z5r9iE';
export const PAYPAL_HOSTED_BUTTON_ID = 'VTMQLTWM9RGKN';
export const PAYPAL_LINK = `https://www.paypal.com/ncp/payment/${PAYPAL_HOSTED_BUTTON_ID}`;
export const PAYPAL_QR_SRC = '/giving/paypal-qr.png';
export const PAYPAL_SDK_SRC = `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&components=hosted-buttons&disable-funding=venmo&currency=USD`;
